// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".countIcon[data-v-f002dc72]{position:absolute;top:0;left:0;transform:translate(13px,-50%);background-color:var(--messageCountBackground);border-radius:8px;color:var(--messageCountColor);min-width:15px}.countIcon[data-v-f002dc72]:focus,.countIcon[data-v-f002dc72]:hover{background-color:var(--messageCountBackgroundActive);color:var(--messageCountColorActive);box-shadow:unset}", ""]);
// Exports
module.exports = exports;
